import React from "react";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { PanelMenu } from "primereact/panelmenu";
import { Link, useNavigate } from "react-router-dom"; // [EXPERT_ANALYSIS]: Importación de useNavigate - Permite la navegación programática después del cierre de sesión. - [IMPACTO]: Habilita la redirección de usuario.
import { logout } from "./Utils/auth"; // [EXPERT_ANALYSIS]: Importación de la función logout - Reutiliza la lógica de cierre de sesión existente para mantener la consistencia y la separación de preocupaciones. - [IMPACTO]: Facilita el manejo de la sesión del usuario.
import "./styles/Menu.css";

const Menu = ({ language, setLanguageHandler, isVisible, onToggleMenu }) => {
  const navigate = useNavigate(); // [EXPERT_ANALYSIS]: Inicialización de useNavigate - Obtiene la función de navegación para redirigir al usuario. - [IMPACTO]: Permite la redirección a la página de login.

  // [EXPERT_ANALYSIS]: Definición de la función handleLogout - Encapsula la lógica de cierre de sesión. - [IMPACTO]: Mejora la modularidad y legibilidad del código.
  const handleLogout = () => {
    logout(navigate); // [EXPERT_ANALYSIS]: Llamada a la función logout - Ejecuta el proceso de cierre de sesión y redirige al usuario. - [IMPACTO]: Cierra la sesión del usuario y lo lleva a la página de inicio de sesión.
  };

  // Items del menú
  const items = [
    {
      label:
        language === "es" ? "Maestros" : language === "en" ? "Masters" : "大师",
      icon: "pi pi-fw pi-folder",
      items: [
        {
          label:
            language === "es"
              ? "Clientes"
              : language === "en"
                ? "Clients"
                : "客户",
          icon: "pi pi-fw pi-user",
          template: (item, options) => (
            <Link to="/clientes" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
        {
          label:
            language === "es"
              ? "Ubicaciones"
              : language === "en"
                ? "Countries List"
                : "国家名单",
          icon: "pi pi-fw pi-globe",
          template: (item, options) => (
            <Link to="/paises" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
      ],
    },
    {
      label:
        language === "es" ? "Pedidos" : language === "en" ? "Orders" : "订单",
      icon: "pi pi-fw pi-shopping-cart",
      items: [
        {
          label:
            language === "es"
              ? "Gestión Pedidos"
              : language === "en"
                ? "Manage Orders"
                : "订单管理",
          icon: "pi pi-fw pi-list",
          template: (item, options) => (
            <Link to="/listapedidos" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
        {
          label:
            language === "es"
              ? "Historico Pedidos"
              : language === "en"
                ? "Order Record"
                : "订单管理",
          icon: "pi pi-fw pi-list",
          template: (item, options) => (
            <Link to="/historicopedidos" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
      ],
    },
    {
      label:
        language === "es"
          ? "Contenedores"
          : language === "en"
            ? "Containers"
            : "集装箱",
      icon: "pi pi-fw pi-box",
      items: [
        {
          label:
            language === "es"
              ? "Gestion Contenedores"
              : language === "en"
                ? "Containers List"
                : "集装箱列表",
          icon: "pi pi-fw pi-table",
          template: (item, options) => (
            <Link to="/listacontenedores" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
        {
          label:
            language === "es"
              ? "Historico Contenedores"
              : language === "en"
                ? "Containers Record"
                : "集装箱列表",
          icon: "pi pi-fw pi-table",
          template: (item, options) => (
            <Link to="/historicocontenedores" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
      ],
    },
    /* {
      label: language === "es" ? "BL" : language === "en" ? "BL" : "提单",
      icon: "pi pi-file",
      items: [
        {
          label: language === "es" ? "Gestión BL" : language === "en" ? "BL Management" : "提单管理",
          icon: "pi pi-fw pi-table",
          template: (item, options) => (
            <Link to="/billoflading" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
      ],
    }, */
  ];

  return (
    <div>
      {/* Menú lateral */}
      <Sidebar
        visible={isVisible}
        onHide={onToggleMenu}
        className="custom-sidebar"
      >
        <div className="menu-header">
          <img
            src="/Img/carga.png"
            alt="Logo"
            className="logo"
            style={{ width: "50px", height: "auto" }}
          />
        </div>

        <PanelMenu model={items} className="menu-content" />

        {/* [EXPERT_ANALYSIS]: Botón de Cerrar Sesión - Proporciona una interfaz para que el usuario cierre su sesión. - [IMPACTO]: Mejora la usabilidad y seguridad de la aplicación. */}
        <button className="logout-button" onClick={handleLogout}>
          Cerrar Sesión
        </button>

        {/* Idiomas */}
        <div className="language-buttons">
          <button
            className="language-button"
            onClick={() => setLanguageHandler("es")}
          >
            <img
              src="/Img/colombia.png"
              alt="Español"
              className="language-icon"
            />
            <span>Español</span>
          </button>
          <button
            className="language-button"
            onClick={() => setLanguageHandler("en")}
          >
            <img
              src="/Img/estados-unidos.png"
              alt="English"
              className="language-icon"
            />
            <span>English</span>
          </button>
          <button
            className="language-button"
            onClick={() => setLanguageHandler("zh")}
          >
            <img src="/Img/china.png" alt="中文" className="language-icon" />
            <span>中文</span>
          </button>
        </div>
      </Sidebar>

      {/* Botón para abrir el menú */}
      <Button
        icon="pi pi-bars"
        className="p-button-rounded p-button-text toggle-btn"
        onClick={onToggleMenu}
      />
    </div>
  );
};

export default Menu;

/* [EXPERT_COMMENT]: Código original de la entrada "Nuevo Cliente" - Mantenido aquí según la solicitud del usuario. */
/*
        {
          label: language === "es" ? "Nuevo Cliente" : language === "en" ? "New Client" : "新客户",
          icon: "pi pi-fw pi-user-plus",
          template: (item, options) => (
            <Link to="/crearcliente" className={options.className}>
              <span className={options.labelClassName}>{item.label}</span>
            </Link>
          ),
        },
*/
